import { render, staticRenderFns } from "./CfopRegra.vue?vue&type=template&id=5524c547"
import script from "./CfopRegra.vue?vue&type=script&lang=js"
export * from "./CfopRegra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports